import { ThemeUICSSObject } from '@apia/theme';
import { collector } from './collector';
import { speedui } from './speedui';
/* IMPORT HERE */

export const util: ThemeUICSSObject = {
  collector,
  speedui,
  /* PREPEND HERE */
};
